// Auto-scroll helper for the stacked onboarding/add-language layouts: after a
// successful pick, nudge the next unanswered question into view so the two
// questions below the fold don't get missed (Unit 2 of the
// onboarding-language-step UX spec). Deliberately container-agnostic —
// scrollIntoView scrolls whichever ancestor overflows (the .modal-body on
// desktop, the .modal-content on mobile), so callers pass only the section
// element, never the scroll container.

// Delay before scrolling, so the selected-card state visibly paints first.
// Mirrors the auto-advance delay in AddLanguageSteps.vue.
const SCROLL_DELAY_MS = 150;

export function prefersReducedMotion() {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

// Returns a controller holding a single pending scroll timer.
//
// scrollToSection(el, isStillWanted): schedule a scroll to `el` after the
//   paint delay. `isStillWanted` is re-checked WHEN THE TIMER FIRES (not when
//   scheduled), so a scroll toward a question the user answered during the
//   delay window is skipped, and a re-tap after answering never yanks the page.
//   Consecutive calls replace the pending timer rather than queuing a second.
//
// cancelScroll(): clear any pending timer. Call it on unmount, on wizard step
//   change, and on modal close/submit so a delayed callback can't fire against
//   a detached section.
export function useScrollToSection() {
  let pendingTimer = null;

  const cancelScroll = () => {
    if (pendingTimer !== null) {
      clearTimeout(pendingTimer);
      pendingTimer = null;
    }
  };

  const scrollToSection = (el, isStillWanted) => {
    cancelScroll();
    if (!el) return;
    pendingTimer = setTimeout(() => {
      pendingTimer = null;
      if (!isStillWanted()) return;
      el.scrollIntoView({
        behavior: prefersReducedMotion() ? "auto" : "smooth",
        block: "start",
      });
    }, SCROLL_DELAY_MS);
  };

  return { scrollToSection, cancelScroll };
}
